import axios from 'axios'

const getCorralonesConProducto = async (obj, localidad_id) => {
    try {
        return await axios({
            method: "get",
            url: `https://panel.tensolite.com/api/sucursalesCorralonesTensolite/provincia/${localidad_id}`,
            responseType: 'json',
            data: {...obj, localidad_id}
        });

    } catch (error) {
        console.log(error)
    }
}

export default getCorralonesConProducto